import { render, staticRenderFns } from "./BrowserDiagram.vue?vue&type=template&id=5c492331&"
import script from "./BrowserDiagram.vue?vue&type=script&lang=js&"
export * from "./BrowserDiagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports